var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyBroadcast = function SvgImgEmptyBroadcast(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    transform: "translate(40 13)"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.3,
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M9 0h15a9 9 0 0 1 9 9v2.5a9 9 0 0 1-9 9h-2.664l-3.278 3.558a.5.5 0 0 1-.868-.339V20.5H9a9 9 0 0 1-9-9V9a9 9 0 0 1 9-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 11,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(6 30)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6.865 9.965C14.212 9.785 20.257 9.129 25 8c5.534-1.318 10.678-3.61 15.434-6.878A1 1 0 0 1 42 1.946v29.838a1 1 0 0 1-1.62.785C36.863 29.793 31.736 27.604 25 26c-5.818-1.385-11.899-2.11-18.244-2.175A6.826 6.826 0 0 1 0 17a7.038 7.038 0 0 1 6.865-7.035z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4.5,
    x: 11,
    y: 12.5,
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    d: "M4.448 10.506 9 10v14l-4.552-.506A5 5 0 0 1 0 18.524v-3.049a5 5 0 0 1 4.448-4.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M9 10v13.498M42 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2m-29.515 2.082v11a2 2 0 0 0 2 2h.924a2 2 0 0 0 2-2v-10.31M17 14v1.5m3-1.5v1.5M14 14v1.5"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyBroadcast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-empty-broadcast.ce62fc70ca90bc0427963a742677c7ef.svg";